<template>
  <div class="abs" id="About">
    <p class="title" name="About">关于我们</p>
    <div class="main">
      <div class="abs-main">
        <el-row>
          <el-col :span="9" :xs="24" class="abs-img">
            <img :src="require(`@images/abs_1.png`)" />
          </el-col>
          <el-col class="abs-text-info" :span="14" :xs="24">
            <div class="abs-text-content">
              <p class="descript">我们是一家以技术驱动的广告技术公司，在中国和香港设立分公司，我们在程序化广告领域有逾十几年的经验，团队大部分成员曾就职于谷歌、腾讯、百度等广告部门。我们拥有优质的、符合IAB资源的开发者流量资源，利用我们的反作弊技术，为全球知名的品牌广告主服务。</p>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="abs-partner">
        <h2 class="sub-title">合作伙伴</h2>
        <el-row :gutter="70">
          <el-col :span="8" :xs="24">
            <img v-for="(item, index) in Array(4)" :src="require(`@images/partner_${index+1}.png`)" :key="index" alt="" />
          </el-col>
          <el-col :span="8" :xs="24">
            <img v-for="(item, index) in Array(3)" :src="require(`@images/partner_${index+5}.png`)" :key="index" alt="" />
          </el-col>
          <el-col :span="8" :xs="24">
            <img v-for="(item, index) in Array(3)" :src="require(`@images/partner_${index+8}.png`)" :key="index" alt="" />
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "About",
  data: function () {
    return {
    };
  }
};
</script>
<style lang="scss" scoped>
.abs {
  background: #ffffff;
  position: relative;
  box-shadow: $section-box-shadow;
  padding: 1px 0 px2rem(40) 0;
  .main {
    .abs-main {
      max-width: px2rem(1050);
      margin: 0 auto;
      .el-row {
        margin: px2rem(50) auto;
        min-height: px2rem(250);
        .abs-img {
          justify-content: center;
          align-items: center;
          display: flex;
          overflow: hidden;
          height: 100%;
          img {
            width: 90%;
            border-radius: px2rem(15);
            object-fit: contain;
          }
        }
        .abs-text-info{
          height: 100%;
          justify-content: center;
          align-items: center;
          display: flex;
          .abs-text-content {
            text-align: left;
            padding: 0 px2rem(20);
          }
        }
      }
    }
    .abs-partner {
      margin-top: px2rem(20);
      max-width: px2rem(1000);
      margin: 0 auto;
      .el-row {
        margin-top: px2rem(40);
        .el-col {
          img {
            margin: 0 auto;
            margin-bottom: px2rem(20);
            display: block;
            width: px2rem(220);
          }
        }
      }
    }
  }
}
</style>